import { StringSchema } from 'yup'
import { Message } from 'yup/lib/types'

const nameRegExp = /(^[A-Za-z]{3,16})([ ]{0,1})([A-Za-z]{3,16})?([ ]{0,1})?([A-Za-z]{3,16})?([ ]{0,1})?([A-Za-z]{3,16})/g

export function name(this: StringSchema, message?: Message<{ regex: RegExp }>) {
  return this.test('name', function (value?: string) {
    return (
      (value && nameRegExp.test(value)) ||
      this.createError({
        type: 'name',
        path: this.path,
        message: message || 'invalid_full_name'
      })
    )
  })
}
